// Header cluster in the top-right.
//
// Expand/collapse remain commented out — fullscreen mode has no affordance
// without the full AgentForgeBar. Minimize is re-enabled: it docks the chat
// to the bottom bar (AgentForgeBar in minimized-only mode, CORE-4669).
//
// Close dismisses entirely (resets mode to docked via handleClose in
// ThreadContainer).

import { Flex } from '@chakra-ui/react';
import { Button } from '@kula-ai/components';
import { XClose } from '@kula-ai/icons-core';
import { ICON_SIZE } from '../../constants';
import type { WindowControlsProps } from './WindowControls.types';

export const WindowControls = ({ onClose }: WindowControlsProps) => (
  <Flex align="center" gap="2px" flexShrink={0}>
    <Button
      size="icon"
      variant="quaternary"
      aria-label="Close chat window"
      onClick={onClose}
    >
      <XClose size={ICON_SIZE} color="currentColor" />
    </Button>
  </Flex>
);
